import React from 'react';
import EventManagement from '@/pages/admin/EventManagement';

const DemoEventManagement: React.FC = () => {
  // EventManagement reads eventId from URL params via useParams()
  return <EventManagement />;
};

export default DemoEventManagement;
